import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../../constants/AuthConstant";
import tunjanganService from "../../../services/ref/tunjanganService";
import Cookies from "js-cookie";

export const initialState = {
    loading_tunjangan: false,
    data_tunjangan: [],
    data_import: [],
    showMessage:false,
    message:'',
}


export const getDataTunjangan = createAsyncThunk('tunjangan/data',async (data, { rejectWithValue }) => {
    try {
        const response = await tunjanganService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getaDataImport = createAsyncThunk('tunjangan/dataimport',async (data, { rejectWithValue }) => {
    try {
        const response = await tunjanganService.data_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const emptyDataImport = createAsyncThunk('tunjangan/emptyimport',async (data, { rejectWithValue }) => {
    try {
        const response = await tunjanganService.empty_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const saveDataImport = createAsyncThunk('tunjangan/saveimport',async (data, { rejectWithValue }) => {
    try {
        const response = await tunjanganService.save_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const tunjanganSlice = createSlice({
    name: 'tunjangan',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_tunjangan = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataTunjangan.fulfilled, (state, action) => {
                state.loading_tunjangan = false
                state.data_tunjangan = action.payload??[]
            })
            .addCase(getDataTunjangan.pending, (state) => {
                state.loading_tunjangan = true
            })
            .addCase(getDataTunjangan.rejected, (state, action) => {
                state.loading_tunjangan = false
                state.data_tunjangan = action.payload
            })
            .addCase(getaDataImport.fulfilled, (state, action) => {
                state.loading_tunjangan = false
                state.data_import = action.payload??[]
            })
            .addCase(getaDataImport.pending, (state) => {
                state.loading_tunjangan = true
            })
            .addCase(getaDataImport.rejected, (state, action) => {
                state.loading_tunjangan = false
                state.data_import = action.payload
            })
    },
})

export const {
    showLoading,
} = tunjanganSlice.actions

export default tunjanganSlice.reducer
